import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-news-hero-card',
  templateUrl: './news-hero-card.component.html',
  styleUrls: ['./news-hero-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsHeroCardComponent implements OnInit {
  @Input() item: any;

  constructor(
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
  }

  safeStyle(url: string) {
    return this.sanitizer.bypassSecurityTrustStyle(`background-image: url('${url}')`);
  }

}
